var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collect"},[_c('div',{class:_vm.isCoollect ? 'collected' : 'coollect',attrs:{"id":"coollect"},on:{"click":_vm.coolectchange}},[_vm._v(" "+_vm._s(_vm.isCoollect ? '已收藏' : '收藏店铺')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }